// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oq-9";
export var arrowButtonContainer = "_oq-5";
export var arrowButtonIcon = "_oq-6";
export var carouselArrowButton = "_oq-2";
export var carouselElementContainer = "_oq-1";
export var currentSlide = "_oq-8";
export var left = "_oq-3";
export var otherSlide = "_oq-a";
export var productCarouselContainer = "_oq-0";
export var right = "_oq-4";
export var sliderOverflow = "_oq-7";